import { configureStore } from '@reduxjs/toolkit';
import languageReducer from './languageSlice';
import accessibilityReducer from './accessibilitySlice';
import errorReducer from './errorSlice';
import loaderReducer from './loaderSlice';
import authReducer from '../../features/auth/store/authSlice';
import shopReducer from './shopSlice';
import shiftManagementReducer from './shiftManagementSlice';
import repairReducer from './repairSlice';
import menuReducer from './menuSlice';
import technicianReducer from './technicianSlice';
import appVersionReducer from './appVersionSlice';
import userReducer from './userSlice';
import novaAIReducer from './novaAISlice';
import themeReducer from './themeSlice';
import quickAssistReducer from './quickAssistSlice';

const store = configureStore({
  reducer: {
    language: languageReducer,
    error: errorReducer,
    auth: authReducer,
    loader: loaderReducer,
    shop: shopReducer,
    shiftManagement: shiftManagementReducer,
    repair: repairReducer,
    menu: menuReducer,
    technician: technicianReducer,
    accessibility: accessibilityReducer,
    appVersion: appVersionReducer,
    user: userReducer,
    novaAI: novaAIReducer,
    theme: themeReducer,
    quickAssist: quickAssistReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
